import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './file-list-filter-category.component.scss';
var FileListFilterCategory = /** @class */ (function (_super) {
    tslib_1.__extends(FileListFilterCategory, _super);
    function FileListFilterCategory(element) {
        return _super.call(this, element) || this;
    }
    FileListFilterCategory.prototype.init = function () {
        this.selectCategory = this.element.querySelector('.js-select-category');
        this.selectBox = this.element.querySelector('.file-list-filter-category__form__select--box');
        this.selectBoxCategory = Array.from(this.element.querySelectorAll('.file-list-filter-category__form__select--box__button'));
        this.selectBoxCategoryItem = Array.from(this.element.querySelectorAll('.file-list-filter-category__form__select--box__item'));
    };
    FileListFilterCategory.prototype.changeCategory = function (value) {
        console.log(value);
    };
    FileListFilterCategory.prototype.bindEvents = function () {
        var _this = this;
        // mobile select
        this.selectCategory.addEventListener('change', function (event) {
            var element = event.target;
            var parent = element.closest('.file-list-filter-category__form__select');
            var button = parent.querySelector('.file-list-filter-category__form__select--box__button');
            var text = element.options(element.selectedIndex).innerHTML;
            button.innerHTML = text;
            _this.changeCategory(element.value);
        });
        // desktop button
        this.selectBoxCategory.map(function (item) { return item.addEventListener('click', function (event) {
            if (_this.selectBox.classList.contains('file-list-filter-category__form__select--box__active')) {
                _this.selectBox.classList.remove('file-list-filter-category__form__select--box__active');
            }
            else {
                _this.selectBox.classList.add('file-list-filter-category__form__select--box__active');
            }
        }); });
        // desktop select
        this.selectBoxCategoryItem.map(function (item) { return item.addEventListener('click', function (event) {
            var element = event.target;
            var dataName = element.getAttribute('data-name');
            var dataValue = element.getAttribute('data-value');
            var i;
            var parent = element.closest('.file-list-filter-category__form__select');
            var select = parent.querySelector('select');
            for (i = 0; i < select.length; i++) {
                if (select[i].value === dataValue) {
                    break;
                }
            }
            select.options.selectedIndex = i;
            var container = element.closest('.file-list-filter-category__form__select__desktop-container');
            var button = container.querySelector('.file-list-filter-category__form__select--box__button');
            _this.selectBox.classList.remove('file-list-filter-category__form__select--box__active');
            button.innerHTML = dataName;
            _this.changeCategory(select.value);
        }); });
    };
    return FileListFilterCategory;
}(Base));
export { FileListFilterCategory };



//////////////////
// WEBPACK FOOTER
// ./components/file-list-filter-category/file-list-filter-category.component.ts
// module id = 282
// module chunks = 0